import React from "react";
import styled from "styled-components";
import defaultTheme from "./theme-test-override";
import { ThemeProps, ThemeTemplate } from "./theme-template";

type IconBlockLinkProps = {
    title?: string;
    url?: string;
    icon?: string;
    target?: string;
};

const Container = styled.div<ThemeProps>`
    box-sizing: border-box;
    border: 1px solid ${props => props.theme.colors.monotoneMid};
    &:hover {
        border: 1px solid ${props => props.theme.colors.monotoneMidDark};
    }
    border-radius: 0.3125rem;
    min-height: 9rem;
`;

const Link = styled.a<ThemeProps>`
    display: block;
    padding: 0.75rem;
    height: calc(100% - 1.5rem);
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    text-decoration: none;
    color: ${props => props.theme.colors.monotoneDark};
`;

const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

const Icon = styled.img`
    height: 2.5rem;
    margin: 0 auto 0.75rem;
`;

const Title = styled.span`
    display: block;
`;
Container.defaultProps = {
    theme: {
        ...defaultTheme
    } as ThemeTemplate
};

Link.defaultProps = {
    theme: {
        ...defaultTheme
    } as ThemeTemplate
};
const IconBlockLink = ({ title, url, icon, target }: IconBlockLinkProps) => (
    <Container>
        <Link
            href={url}
            target={target}
            rel={`${target === "_blank" ? "noopener" : ""} noreferrer`}
            className="no-after"
        >
            <ContentWrapper>
                {icon && <Icon src={icon} />}
                <Title className="title">{title}</Title>
            </ContentWrapper>
        </Link>
    </Container>
);

export { IconBlockLink };
